export default __webpack_public_path__ + "img/0a9f8dfcc9276708abc94bd5aa5d7400.svg";